module.exports = __webpack_public_path__ + "img/logo.b949ced8.png";